<div class="page-container">
  <div class="signup-card scrollable-content">

    <div class="signup-header">
      <img [src]="'logos/app-logo-vertical.png' | envPrefix" [attr.alt]="'app.title' | translate"
        class="signup-logo" width="120" height="120" data-testid="signup-logo" />
      <h1>{{ 'auth.signup.title' | translate }}</h1>
      <p>{{ 'auth.signup.subtitle' | translate }}</p>
    </div>

    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">

      <div class="form-group">
        <label for="organizationName">{{ 'auth.signup.orgNameLabel' | translate }}</label>
        <input type="text" id="organizationName" formControlName="organizationName"
          [attr.placeholder]="'auth.signup.orgNamePlaceholder' | translate" data-testid="organization-name-input"
          class="form-input"
          [class.error]="signupForm.get('organizationName')?.invalid && signupForm.get('organizationName')?.touched" />
        <div class="help-text">{{ 'auth.signup.orgNameHelp' | translate }}</div>
        @if (signupForm.get('organizationName')?.invalid && signupForm.get('organizationName')?.touched) {
        <div class="error-message">
          @if (signupForm.get('organizationName')?.errors?.['required']) {
          <span>{{ 'auth.signup.orgNameRequired' |
            translate }}</span>
          }
          @if (signupForm.get('organizationName')?.errors?.['minlength']) {
          <span>{{ 'auth.signup.orgNameMinLength' |
            translate }}</span>
          }
        </div>
        }
      </div>

      <button type="submit" class="signup-button" [disabled]="signupForm.invalid || isSubmitting()"
        data-testid="create-organization-button">
        {{ isSubmitting() ? ('auth.signup.creating' | translate) : ('auth.signup.createOrganization' | translate) }}
      </button>

      <button type="button" class="logout-button" (click)="logout()" data-testid="signup-logout-button">
        {{ 'auth.signup.logout' | translate }}
      </button>

      <p class="signup-note">
        {{ 'auth.signup.termsPrefix' | translate }}
        <a routerLink="/terms" data-testid="signup-terms-link">{{ 'legal.termsOfService' | translate }}</a>
        {{ 'auth.signup.termsAnd' | translate }}
        <a routerLink="/privacy" data-testid="signup-privacy-link">{{ 'legal.privacyPolicy' | translate }}</a>.
      </p>

    </form>
  </div>
</div>
